export interface IHttpParams {
  pageNumber: number;
  pageSize: number;
  fromSmallerToLarger: boolean;
  searchParameter?: string;
}
